import { render } from "./CreateUpdate.vue?vue&type=template&id=010862fb"
import script from "./CreateUpdate.vue?vue&type=script&lang=js"
export * from "./CreateUpdate.vue?vue&type=script&lang=js"
script.render = render

export default script